module.exports = __webpack_public_path__ + "static/media/specs.30dd0605.svg";